module.exports = __webpack_public_path__ + "img/flot7.f2ccf172.svg";